import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var $ :any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent extends AbstractComponent implements OnInit {

  public loginName: string;
  redirecionamento: boolean;

  constructor(
    private sessaoService: SessaoService,
    private spinnerService: Ng4LoadingSpinnerService) {
    super(sessaoService);
  }

  ngOnInit() {
    // Carousel
    setTimeout(function(){
      $('.carousel.carousel-slider').carousel({fullWidth: true}).off('touchstart.carousel');
    }, 600);
    if (this.sessaoService.sessao.configuracaoVisual.listaImagemRotativaVisual &&
      this.sessaoService.sessao.configuracaoVisual.listaImagemRotativaVisual.length > 1){
      setInterval(function() {
        $('.carousel').carousel('next');
      }, 15000);
    }

    // Menu
    $(".btsMenu .btn").removeClass("active activeDrop");
    $(".home").addClass("active");

    $(".menu").click(function(){
      setTimeout(function(){
        $('.carousel.carousel-slider').carousel({fullWidth: true});
      }, 600);
    });

    //Scroll top
    window.scrollTo(0,0);

    this.spinnerService.hide();

    // Close Menu Mobile
    const isMobile = window.matchMedia('only screen and (max-width: 760px)');
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  openLink(link: string){
    if(link !='' && link != null){
    window.open(link);
    }
  }

  slideNext(){
    $('.carousel').carousel('next');
  }
  slidePrev(){
    $('.carousel').carousel('prev');
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/home/home.component.ts